import React from 'react'
import { useSelector, useStore } from 'react-redux'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { selectBatchItemIds } from '../../selectors/itemsSelector'
import { itemIdsToItems } from './itemsTransformers'
import Item from './Item'
import Loading from '../util/Loading'


export default function ItemBatch({ parentItemId, batchId, loading, dispatch, loggedIn, timestamp }) {
  const itemIds = useSelector(state => selectBatchItemIds(state, batchId).filter(id => id !== parentItemId))
  const items = itemIdsToItems(useStore().getState(), itemIds)

  return (
    <div className='item-batch'>
      <Loading loading={ loading }>
        { items.toArray().map(item => (
          <Item
            key={ item.get('id') }
            item={ item }
            dispatch={ dispatch }
            loggedIn={ loggedIn }
            timestamp={ timestamp }
            isInsideBatch={ true }
          />
        )) }
      </Loading>
    </div>
  )
}

ItemBatch.propTypes = exact({
  parentItemId: PropTypes.string.isRequired,
  batchId: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  timestamp: PropTypes.number.isRequired,
})
